import styled from "styled-components/macro";

import { colorIsLight } from "Utilities/Colors/colorUtils";
import { formatCurrencyWithCommas } from "Utilities/Number";

export default function DetailProgressBar({
  amountGiven,
  totalPledged,
  fundColor,
  status,
  percentOfMaxDate,
}) {
  let progressWidth = 0;
  let borderWidth = 0;

  if (amountGiven < totalPledged) {
    progressWidth = amountGiven / totalPledged;
    borderWidth = 100;
  } else {
    progressWidth = 1;
    borderWidth = (totalPledged / amountGiven) * 100;
  }

  if (percentOfMaxDate) {
    if (percentOfMaxDate < 1 || percentOfMaxDate > 99) percentOfMaxDate = false;
    else if (percentOfMaxDate < 6) percentOfMaxDate = 6;
    else if (percentOfMaxDate > 94) percentOfMaxDate = 94;
  }

  return (
    <ProgressBarContainer>
      <ProgressBarBorder
        style={
          status === "closed"
            ? {
                background: "rgba(0,0,0, 0.4)",
                width: borderWidth + "%",
              }
            : { width: borderWidth + "%" }
        }
      >
        <Amount>{formatCurrencyWithCommas(totalPledged, false)}</Amount>
        {percentOfMaxDate && (
          <DateTicker style={{ left: percentOfMaxDate + "%" }} />
        )}
      </ProgressBarBorder>
      {amountGiven > 0 && (
        <ProgressBar
          style={{
            background: fundColor,
            width: "calc((100% - 8px) * " + progressWidth + ")",
          }}
        >
          <Amount darktext={colorIsLight(fundColor, 25)}>
            {formatCurrencyWithCommas(amountGiven, false)}
          </Amount>
        </ProgressBar>
      )}
    </ProgressBarContainer>
  );
}
const ProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
const ProgressBarCommon = styled.div`
  min-width: fit-content;
  display: flex;
  justify-content: flex-end;
`;
const ProgressBarBorder = styled(ProgressBarCommon)`
  border: 2px solid var(--pledgesProgressBarBorder);
  border-radius: 20px;
  box-sizing: border-box;
  height: 40px;
  width: 100%;
  background: var(--pledgesProgressBarBackground);
  min-width: fit-content;
  display: flex;
  justify-content: flex-end;
`;
const ProgressBar = styled(ProgressBarCommon)`
  height: 30px;
  border-radius: 34px;
  position: absolute;
  left: 5px;
  overflow: hidden;
  z-index: 200;
  &::before,
  &::after {
    content: "";
    position: absolute;
    height: 14px;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0)
    );
    z-index: 1;
  }
  &::after {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.25)
    );
    top: auto;
    bottom: 0;
  }
`;

const Amount = styled.div`
  padding: 0 12px;
  font-weight: 600;
  font-size: 18px;
  align-self: center;
  z-index: 100;
  position: relative;
  &::before {
    content: "$";
  }

  ${ProgressBar} & {
    color: ${(props) => (props.darktext ? "#15436a" : "#eceff0")};
    text-shadow: rgba(0, 0, 0, 0.4) 1px 1px 2px;
  }
`;

const DateTicker = styled.div`
  position: absolute;
  border: 8px solid rgba(255, 255, 255, 0);
  border-bottom: 8px solid #fff;
  bottom: 0;
  margin-left: -8px;
  position: absolute;
  z-index: 300;
`;
